import { withPreviewToken } from "../../api.js";

export function withStudentReturnUrl(url) {
  if (!url) {
    return url;
  }

  try {
    const target = new URL(url, window.location.origin);
    if (target.origin !== window.location.origin || !target.pathname.startsWith("/sheet/")) {
      return url;
    }

    const current = new URL(`${window.location.pathname}${window.location.search}${window.location.hash}`, window.location.origin);
    const currentPath = current.pathname.replace(/\/+$/, "");
    let returnUrl = current.searchParams.get("return_url");
    // Unwrap old links back to this same card instead of nesting them again.
    while (returnUrl) {
      const previous = new URL(returnUrl, window.location.origin);
      if (previous.origin !== window.location.origin || !previous.pathname.startsWith("/sheet/")) {
        returnUrl = null;
        break;
      }
      if (previous.pathname.replace(/\/+$/, "") !== currentPath) break;
      returnUrl = previous.searchParams.get("return_url");
    }
    if (returnUrl) current.searchParams.set("return_url", returnUrl);
    else current.searchParams.delete("return_url");

    const destinationReturn = target.pathname.replace(/\/+$/, "") === currentPath
      ? returnUrl
      : `${current.pathname}${current.search}${current.hash}`;
    if (destinationReturn) target.searchParams.set("return_url", destinationReturn);
    else target.searchParams.delete("return_url");

    return withPreviewToken(`${target.pathname}${target.search}${target.hash}`);
  } catch {
    return url;
  }
}
